import QuantityCards from '@scripts/components/quantity-cards'
import PurchasePlans from '@scripts/components/purchase-plans'

customElements.define('quantity-cards-ui', QuantityCards)
customElements.define('purchase-plans-ui', PurchasePlans)